import "./Tag.css";

import { Breadcrumb, message, Table, type TableColumnsType, Tag } from "antd";
import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";

import { SectionHeader, TableMenuDropdown } from "../../_lib/_components";
import {
  deleteTag,
  getTags,
  type TagType,
  useAppSelector,
} from "../../_lib/_store";

export const TagPage = () => {
  const [messageApi, contextHolder] = message.useMessage();
  const { isLoading, tags } = useAppSelector((state) => state.tag);
  const navigate = useNavigate();

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    await getTags(messageApi);
  };

  const columns: TableColumnsType<TagType> = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Display Name",
      dataIndex: "displayName",
      key: "displayName",
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
    },
    {
      title: "Color",
      dataIndex: "color",
      key: "color",
    },
    {
      title: "Category",
      dataIndex: "category",
      key: "category",
    },
    {
      title: "Is Active",
      dataIndex: "isActive",
      key: "isActive",
      render: (v) => <Tag>{v ? "Yes" : "No"}</Tag>,
    },
    {
      title: "",
      dataIndex: "actions",
      key: "actions",
      width: 100,
      render: (_, obj) => (
        <TableMenuDropdown onClick={(key) => handleMenuClick(key, obj)} />
      ),
    },
  ];

  const handleMenuClick = (key: string, obj: TagType) => {
    switch (key) {
      case "show":
        navigate(`/tag/show`, { state: { tag: obj } });
        break;
      case "edit":
        navigate(`/tag/edit`, { state: { tag: obj } });
        break;
      case "delete":
        deleteTag(messageApi, obj?.id, true);
        break;
      default:
        break;
    }
  };

  return (
    <>
      {contextHolder}
      <div className="tag">
        <div className="header">
          <Breadcrumb
            items={[
              {
                title: <Link to="/dashboard">Dashboard</Link>,
              },
              {
                title: "Tag",
              },
            ]}
          />
        </div>
        <SectionHeader dataLength={tags?.length} createRoute="tag" />
        <Table
          sticky
          dataSource={tags}
          columns={columns}
          loading={isLoading}
          scroll={{ x: 1000 }}
          rowKey={"id"}
        />
      </div>
    </>
  );
};
